import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Header.css";
import "../styles/Header-search-fix.css";
import { FaBell, FaSearch, FaChevronDown } from "react-icons/fa";
import avatar from "../assets/avatar.jpg";
import logo from "../assets/logo.png";
import { jwtDecode } from 'jwt-decode';
import SearchAutocomplete from "./SearchAutocomplete";
import NotificationDropdown from "./notifications/NotificationDropdown";
import NotificationBadge from "./notifications/NotificationBadge";
import ThemeSelector from "./ThemeSelector";
// ✅ Importer useAuth
import { useAuth } from "../contexts/AuthContext";
import { useSearch } from "../contexts/SearchContext";
import { useGlobalSearch } from "../hooks/useGlobalSearch";
import useNotifications from "../hooks/useNotifications";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const [showNotifications, setShowNotifications] = useState(false);
  const [userData, setUserData] = useState(null);
  const [userName, setUserName] = useState("Utilisateur");
  const menuRef = useRef();
  const searchRef = useRef();
  const notificationRef = useRef();
  const navigate = useNavigate();
  const { logout } = useAuth(); // ✅ Utiliser la fonction logout du contexte
  const { globalSearch, updateSearch } = useSearch();
  const { unreadCount } = useNotifications();
  const {
    searchQuery,
    searchResults,
    isSearching,
    showResults,
    updateSearchQuery,
    hideResults,
    hasResults
  } = useGlobalSearch();

  // Fermer les menus si clic à l'extérieur
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
      // Fermer les résultats de recherche si clic à l'extérieur
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        hideResults();
      }
      // Fermer les notifications si clic à l'extérieur
      if (notificationRef.current && !notificationRef.current.contains(e.target)) {
        setShowNotifications(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [hideResults]);

  // Récupérer le nom/email depuis le token
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserName(decoded.email);
      } catch (err) {
        console.error("Erreur de décodage du token :", err);
      }
    }
  }, []);

  // Récupérer les infos utilisateur depuis le localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    try {
      if (storedUser && storedUser !== "undefined") {
        const parsed = JSON.parse(storedUser);
        console.log("✅ Données utilisateur chargées :", parsed);
        setUserData(parsed);
      } else {
        console.warn("⚠️ Aucun utilisateur valide dans localStorage.");
      }
    } catch (err) {
      console.error("Erreur de parsing des données utilisateur :", err);
    }
  }, []);

 
   // ✅ Déconnexion via le contexte
  const handleLogout = () => {
    logout(); // met à jour l'état isAuthenticated + clear localStorage
    navigate("/"); // redirige vers la page de login
  };

  const handleGoToSettings = () => {
    setMenuOpen(false);
    navigate("/parametres");
  };

  const openAccountPage = () => {
    setMenuOpen(false);
    navigate("/mon-compte");
  };

  const toggleNotifications = () => {
    setShowNotifications(!showNotifications);
  };

  return (
    <header className="header">
        <div className="header-left">
          <img src={logo} alt="WaaGo" className="logo-image" />
        </div>

        <div className="header-center">
          <div className="search-container" ref={searchRef}>
            <div className="search-bar">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Rechercher clients, prestataires, missions..."
                value={searchQuery}
                onChange={(e) => updateSearchQuery(e.target.value)}
              />
            </div>
            <SearchAutocomplete
              results={searchResults}
              isSearching={isSearching}
              showResults={showResults}
              onHideResults={hideResults}
              searchQuery={searchQuery}
              hasResults={hasResults}
            />
          </div>
        </div>

        <div className="header-right">
          <ThemeSelector />

          <div className="notification-container" ref={notificationRef}>
            <div className="bell-icon-wrapper" onClick={toggleNotifications}>
              <FaBell className={`icon-bell ${showNotifications ? 'active' : ''}`} />
              <NotificationBadge count={unreadCount} />
            </div>

            <NotificationDropdown
              isOpen={showNotifications}
              onToggle={toggleNotifications}
              onClose={() => setShowNotifications(false)}
            />
          </div>

          <div className="user-menu-container" ref={menuRef}>
            <div className="user-info" onClick={() => setMenuOpen(!menuOpen)}>
              <img src={avatar} alt="User Avatar" className="avatar" />
              <div className="user-text">
                <span className="user-name">{userName}</span>
                <span className="user-role">Admin</span>
              </div>
              <FaChevronDown className="dropdown-icon" />
            </div>

            {menuOpen && (
              <div className="dropdown-menu">
                <div className="dropdown-item" onClick={openAccountPage}>
                  Mon compte
                </div>
                <div className="dropdown-item" onClick={handleGoToSettings}>
                  Paramètres
                </div>
                <hr className="dropdown-divider" />
                <div className="dropdown-item logout" onClick={handleLogout}>
                  Déconnexion
                </div>
              </div>
            )}
          </div>
        </div>
    </header>
  );
};

export default Header;
